const btnBurger = document.querySelector('.header__burger')
const menu = document.querySelector('.header__menu')
const closeBtn = document.querySelector('.header__menu__close')
const badgeCloseBtn = document.querySelector('.site__badge__x-icon')
const badge = document.querySelector('.site__badge')
const header = document.querySelector('.header')
const color = header.getAttribute('data-page-color')

btnBurger?.addEventListener('click', () => {
    menu.classList.add('active')
    btnBurger.classList.add('active')
    btnBurger.setAttribute('aria-expanded', btnBurger.classList.contains('active'))
    document.body.style.overflowY = 'hidden'
})

closeBtn?.addEventListener('click', () => {
    menu.classList.remove('active')
    btnBurger.classList.remove('active')
    btnBurger.setAttribute('aria-expanded', btnBurger.classList.contains('active'))
    document.body.style.overflowY = 'auto'
})

badgeCloseBtn.addEventListener('click', () => {
    badge.classList.add('hide')
    localStorage.setItem('badge', 'hide')
})

const isBadgeHidden = localStorage.getItem('badge') !== 'hide'
if (isBadgeHidden) {
    badge.classList.remove('hide')
}

window.onscroll = function () {
    let currentScrollPos = window.pageYOffset

    if (currentScrollPos < 160) {
        header.style.backgroundColor = color
    } else {
        header.style.backgroundColor = 'transparent'
    }
}
